var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sports_item_list"},[_c('div',{staticClass:"header"},[_c('div',[_vm._v(_vm._s(_vm.itemDetail.title))]),_c('div',[_vm._v(_vm._s(_vm.itemDetail.content))])]),_c('div',{staticClass:"body"},[(_vm.itemSubList.length)?_c('ItemList',{attrs:{"itemSubList":_vm.itemSubList}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }